import React, { useEffect, useMemo, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  entityFilter,
  getFilteredAndPaginatedEntities,
  headerSortingClasses,
  sortCaret
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { useModelUIContext } from "../ModelUIContext";
import * as actions from "../../_redux/ModelAction";
import { SearchText } from "../../../../../shared/components/SearchText";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import {BoootstrapTable} from "../../../../../shared/components/BoootstrapTable";

export function ModelTable() {
  const modelUIContext = useModelUIContext();
  const modelUIProps = useMemo(() => modelUIContext, [modelUIContext]);

  const columns = [
    {
      dataField: "#",
      text: "Index",
      formatter: (cell, row, rowIndex) => {
        return <span>{(page - 1) * size + (rowIndex + 1)}</span>;
      }
    },
    {
      dataField: "model_name",
      text: "Model Name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: {
        minWidth: "165px"
      }
    },
    {
      dataField: "model_description",
      text: "Model Description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "model_infer_cpu_speed",
      text: "CPU Speed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "model_infer_gpu_speed",
      text: "GPU Speed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "model_size",
      text: "model Size",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: columnFormatters.StatusColumnFormatter,
      formatExtraData: {
        openChangeStatusDialog: modelUIProps.openChangeStatusDialog
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditModelDialog: modelUIProps.openEditModelDialog,
        openViewModelDialog: modelUIProps.openViewModelDialog
      },
      style: {
        minWidth: "125px"
      }
    }
  ];

  const { currentState } = useSelector(
    state => ({ currentState: state.model }),
    shallowEqual
  );

  const { entities, totalmodels, page, size } = currentState;
  const [filterEntities, setFilterEntities] = useState(entities);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const searchInput = useRef("");
  let currentItems = getFilteredAndPaginatedEntities(
    filterEntities || entities,
    modelUIProps.queryParams
  );

  //Filter data for model type
  const filterModel = e => {
    // const searchStr = e?.target?.value || searchInput.current.value;
    const keys = [
      "model_name",
      "model_description",
      "model_infer_cpu_speed",
      "model_infer_gpu_speed",
      "model_size"
    ];
    currentItems = entityFilter(
      entities || filterEntities,
      null,
      keys,
      modelUIProps.queryParams,
      setFilterEntities
    );
  };

  //State Change Handlers
  const dispatch = useDispatch();
  useEffect(() => {
    setLoader(true);
    dispatch(actions.fetchModels(1, 10, search)).then();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [modelUIProps.queryParams, dispatch]);

  useEffect(() => {
    filterModel();
    // eslint-disable-next-line
  }, [entities]);
  const onPageChange = (page, sizePerPage) => {
    dispatch(actions.fetchModels(page, sizePerPage, search));
  };

  const onSizePerPageChange = sizePerPage => {
    dispatch(actions.fetchModels(1, sizePerPage, search));
  };
  const onKeyPressHandler = e => {
    if (e.key === "Enter") {
      dispatch(actions.fetchModels(1, size, search));
    }
  };

  const onChangeSearch = e => {
    const searchStr = e?.target?.value || searchInput.current.value;
    setSearch(searchStr);
  };

  return (
    <>
      <div>
        <div className=" mb-5 pagination-tab" />
        <BlockUi tag="div" blocking={loader} color="#147b82">
          <SearchText
            reference={searchInput}
            onChangeHandler={onChangeSearch}
            onKeyDown={onKeyPressHandler}
          />
          {currentItems && currentItems.length > 0 ? (
            <BoootstrapTable
              sizePerPageList={[
                { text: "10", value: 10 },
                { text: "5", value: 5 },
                { text: "3", value: 3 }
              ]}
              hideSizePerPage={false}
              showTotal={true}
              alwaysShowAllBtns={true}
              hidePageListOnlyOnePage={true}
              columns={columns}
              data={currentItems}
              sizePerPage={size}
              page={page}
              totalSize={totalmodels}
              onTableChange={onPageChange}
              sizePerPageChange={onSizePerPageChange}
            />
          ) : (
            <h3 className={"table-center"}>No Data Available</h3>
          )}
        </BlockUi>
      </div>
    </>
  );
}
